"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../styles");
const Logo = exports.Logo = (0, _mui.styled)(_styles.OriflameLogoSvg)(({
  theme
}) => ({
  [theme.breakpoints.up('md')]: {
    width: 160
  }
}));
